import React from "react";
import { Button, Card, Descriptions, Empty, Space, Tag } from "antd";
import { SystemVersion } from "../../../../Api";
import { APP_VERSION } from "../../../../Constant";

interface CurrentVersionCardProps {
  current: SystemVersion | null;
  lastMigrationAt: string | null;
  lastSeedAt: string | null;
  beVersion: string | null;
  migrating: boolean;
  seeding: boolean;
  onMigrate: () => void;
  onSeed: () => void;
  formatDateTime: (value: string | null) => string;
}

export const CurrentVersionCard: React.FC<CurrentVersionCardProps> = ({
  current,
  lastMigrationAt,
  lastSeedAt,
  beVersion,
  migrating,
  seeding,
  onMigrate,
  onSeed,
  formatDateTime,
}) => {
  const versionMatched = current?.version === APP_VERSION && APP_VERSION === beVersion;
  const migrationDisabled = !current || current.migrated_at !== null || !versionMatched;
  const seedDisabled = !current || current.seeded_at !== null || !versionMatched;

  return (
    <Card size="small" title="Current Deployed Version">
      {current ? (
        <Descriptions column={{ xs: 1, md: 2 }} bordered size="small">
          <Descriptions.Item label="Version">
            <Tag color="blue">{current.version}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Created At">
            {formatDateTime(current.created_at)}
          </Descriptions.Item>
          <Descriptions.Item label="Last Migration">
            {formatDateTime(lastMigrationAt)}
          </Descriptions.Item>
          <Descriptions.Item label="Last Seed">
            {formatDateTime(lastSeedAt)}
          </Descriptions.Item>
          <Descriptions.Item label="Notes" span={2}>
            <span className="whitespace-pre-wrap">{current.notes || "—"}</span>
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <Empty description="No version deployed yet" />
      )}

      <Space className="mt-4">
        <Button
          type="primary"
          loading={migrating}
          onClick={onMigrate}
          disabled={migrationDisabled}
        >
          Run Migrations
        </Button>
        <Button
          loading={seeding}
          onClick={onSeed}
          disabled={seedDisabled}
        >
          Run Seeds
        </Button>
      </Space>
    </Card>
  );
};
